import * as React from "react";
import { memo } from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "../lib/utils";

const inputVariants = cva(
  "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex w-full min-w-0 rounded-[10px] border bg-transparent px-3 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:items-center file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm focus-visible:border-[#eeeeee] focus-visible:ring-[#eeeeee]/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
  {
    variants: {
      size: {
        default: "h-8 py-2 file:h-6",
        small: "h-8 py-1 file:h-6",
      },
    },
    defaultVariants: {
      size: "default",
    },
  }
);

export interface InputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "size">,
    VariantProps<typeof inputVariants> {}

// Memoized so a controlled Input skips re-rendering when its parent form re-renders on an
// unrelated field's keystroke, provided its props keep stable identity.
// TODO: during migration add variant that makes it inline-text editing with not decoration
const Input = memo(
  React.forwardRef<HTMLInputElement, InputProps>(({ className, type, size, ...props }, ref) => {
    return (
      <input
        type={type}
        data-slot="input"
        className={cn(inputVariants({ size, className }), type === "file" && "border-0 shadow-none px-0")}
        ref={ref}
        {...props}
      />
    );
  })
);
Input.displayName = "Input";

export { Input };
